import React from 'react';
import { getConversationsList } from 'api/inbox';
import { opsGetAiEditorConfig } from 'api/operation';
import { TConversation } from 'types/inbox';
import InboxStore from 'store/Inbox';

const useInboxConversations = (
    size?: number,
    clientId?: string,
): [TConversation[] | undefined, boolean, (size?: number, clientId?: string) => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TConversation[]>();
    const [set, get] = InboxStore.useStore();
    const fetchData = async (_size?: number, _clientId?: string) => {
        try {
            loading.current = true;
            const result = await getConversationsList(1, _size || size || 50, _clientId);
            if (!result.error) {
                const data: TConversation[] = result?.data?.data?.records || [];
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData(size, clientId);
        }
    }, [size, clientId]);

    return [items, loading.current, fetchData];
};

export default useInboxConversations;
